var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-row',[_c('v-col',{staticClass:"text-center"},[_c('h4',[_vm._v("En construccion")])])],1),_c('v-row',[_c('v-col',{staticClass:"text-center"},[_c('v-btn',{on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v("Volver")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }